import { render, staticRenderFns } from "./CollectionPicker.vue?vue&type=template&id=6b1b7ac4"
import script from "./CollectionPicker.vue?vue&type=script&lang=ts"
export * from "./CollectionPicker.vue?vue&type=script&lang=ts"
import style0 from "./CollectionPicker.vue?vue&type=style&index=0&id=6b1b7ac4&prod&lang=styl"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports